// api
import axios from 'axios';
// utils
import { url } from 'utils/urls';
import { getFormEncodedData } from 'utils/auth/getFormEncodedData';


export const userSignInCall = (data) => {
    const encodedData = getFormEncodedData({username: data.email, password: data.password});
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    return axios.post(url.auth.signIn, encodedData, { headers, withCredentials: true});
};

export const userSignOutCall = () => axios.get(`${url.auth.signOut}`, {withCredentials: true});
export const unmockUserCall = () =>  {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.auth.unmockUser, {}, { headers, withCredentials: true} )
};
export const userPermissionsCall = userUUID => axios.get(`${url.auth.usersAPI}/${userUUID}/permissions`, {withCredentials: true});
export const requestDemoCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.auth.createLead, data, { headers, withCredentials: true})
};
export const userSendResetEmail = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.auth.sendResetEmail, data, { headers, withCredentials: true})
};
export const resetPasswordCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.put(url.auth.resetPassword, data, { headers, withCredentials: true})
};
export const createUserCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.auth.createUser, data, { headers, withCredentials: true})
};
export const getAuthTokenDataCall = tokenUUID => axios.get(`${url.auth.getTokenData}?tokenUUID=${tokenUUID}`, {withCredentials: true});

export const asyncCompleteSignUp = data => (new Promise((resolve, reject) => {
    setTimeout(() => {
        Math.floor(100 * Math.random()) < 51 ? resolve({ data }) : reject("NETWORK ERROR")
    }, 500)
}));

export const userExtendSession = () => axios.put(`${url.auth.extendSession}`, {} ,{withCredentials: true});